import RsaGestioneCamere from "..";

const routes = [
    { name: "RsaGestioneCamereListPage", path: "/rsagestionecamere", component: RsaGestioneCamere.RsaGestioneCamereListPage, meta: { title: " Gestione Camere" } },
    { name: "RsaGestioneCamereListView", path: "/rsagestionecamere/view/:id", component: RsaGestioneCamere.RsaGestioneCamereViewPage, meta: { title: " Gestione Camere" } },
    { name: "RsaGestioneCamereStoricoViewPage", path: "/rsagestionecamerestorico/view/:id", component: RsaGestioneCamere.RsaGestioneCameraStoricoViewPage, meta: { title: " Gestione Camere" } },

    // { name: "StrutturaView", path: "/struttura/view/:id", component: Strutture.StrutturaView, meta: { title: "strutture.lblTitle" } },
    // { name: "StrutturaEdit", path: "/struttura/edit/:id", component: Strutture.StrutturaEdit, meta: { title: "strutture.lblTitle" } },
];

export default routes;
